<div class="container-fluid mt-3">
    <div class="card">
        <div class="card-header"><strong>{{ 'kobeac.profile' | transloco }}</strong></div>
        <div class="card-body">
            <tabset>
                <tab [heading]="'kobeac.profile' | transloco">
                    <form class="mt-3">
                        <div class="form-group">
                            <label>{{ 'kobeac.display_name' | transloco }}</label>
                            <input type="text" class="form-control" [(ngModel)]="profile.name" name="displayName" [placeholder]="'kobeac.display_name' | transloco">
                        </div>
                        <div class="form-group">
                            <label>{{ 'kobeac.email_address' | transloco }}</label>
                            <input type="email" class="form-control" [(ngModel)]="user.email" name="email" [placeholder]="'kobeac.email_optional' | transloco">
                        </div>
                        <div class="form-group" *ngIf="isKobeAdmin">
                            <label>{{ 'kobeac.default_auction' | transloco }}</label>
                            <select class="form-control" [(ngModel)]="profile.auction" name="auction" [compareWith]="compareAuction">
                                <option [ngValue]="null">{{ 'kobeac.not_set' | transloco }}</option>
                                <option *ngFor="let a of auctions" [ngValue]="a">{{ auctionDateFormatter(0, a['日付']) }}</option>
                            </select>
                        </div>
                        <button (click)="saveProfile()" [disabled]="!canSaveProfile()" class="btn btn-primary btn-block btn-lg">{{ 'common.save' | transloco }}</button>
                    </form>
                </tab>
                <tab [heading]="'kobeac.password' | transloco">
                    <form class="mt-3">
                        <div class="form-group">
                            <label>{{ 'kobeac.password' | transloco }}</label>
                            <input type="password" class="form-control" [(ngModel)]="password" name="password" [placeholder]="'kobeac.min6' | transloco">
                        </div>
                        <div class="form-group">
                            <label>{{ 'kobeac.password_confirm' | transloco }}</label>
                            <input type="password" class="form-control" [(ngModel)]="confirm" name="confirm">
                        </div>
                        <button (click)="savePassword()" [disabled]="!canSavePassword()" class="btn btn-primary btn-block btn-lg">{{ 'kobeac.change' | transloco }}</button>
                    </form>
                </tab>
            </tabset>
        </div>
    </div>
</div>
